import React from 'react';
import styled from 'styled-components';

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
`;

const LabelBar = styled.div`
  background: #566f8d;
  color: #fff;
  font-size: 16px;
  text-align: center;
  padding: 6px 12px;
  border-radius: 30px 30px 0 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Image = styled.div<{ imageUrl?: string; hasLabel?: boolean }>`
  width: 100%;
  aspect-ratio: 4 / 3;
  position: relative;
  background-image: ${({ imageUrl }) => (imageUrl ? `url(${imageUrl})` : 'none')};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #f5f5f5;
  border-radius: ${({ hasLabel }) => (hasLabel ? '0 0 30px 30px' : '30px')};
  cursor: pointer;
`;

interface VehicleImageCardProps {
  imageUrl?: string;
  label?: React.ReactNode;
  onClick?: () => void;
  badge?: React.ReactNode;
}

const VehicleImageCard = ({ imageUrl, label, onClick, badge }: VehicleImageCardProps) => (
  <ImageWrapper>
    {label && <LabelBar>{label}</LabelBar>}
    <Image imageUrl={imageUrl} hasLabel={!!label} onClick={onClick}>
      {badge}
    </Image>
  </ImageWrapper>
);

export default VehicleImageCard;
